import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface ConnectedProvider {
  provider: string;
  username: string;
  connected_at: string;
  token_valid?: boolean;
  member_id?: string;
  member_name?: string;
  member_email?: string;
}

export function useIntegrations() {
  const query = useQuery({
    queryKey: queryKeys.integrations.status(),
    queryFn: async () => {
      const data = await api<{ providers: ConnectedProvider[] }>(
        "/api/v2/git-auth/status",
      );
      return data.providers;
    },
  });

  const refetch = useCallback(() => {
    void query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.refetch]);

  return {
    providers: query.data ?? [],
    loading: query.isLoading,
    error: query.error ? "Failed to load integrations" : null,
    refetch,
  };
}
